export const MAIN_PRODUCTION_HOST = 'app.venus.io';
export const ALT_PRODUCTION_HOST = 'app-alt.venus.io';
export const productionHosts = [MAIN_PRODUCTION_HOST, ALT_PRODUCTION_HOST];
